import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../localization.service';
import { LocalizationDatePipe } from './localization-date.pipe';
import { LocalizationTimePipe } from './localization-time.pipe';

@Pipe({
    name: 'formatRelativeTime',
})
export class LocalizationRelativeTimePipe implements PipeTransform {
    constructor(
        private _LocalizationTimePipe: LocalizationTimePipe,
        private _LocalizationDatePipe: LocalizationDatePipe,
        private _LocalizationService: LocalizationService
    ) {}

    transform(value: string): string {
        try {
            let displayingTimeString = '';
            const targetTime = Date.parse(value);

            const today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);
            const todayStart =  Date.parse(today.toString());

            // to prepare yesterday time
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const yesterdayStart = Date.parse(yesterday.toString());

            // prepare recent week time
            const recentWeekStartDay = new Date(today);
            recentWeekStartDay.setDate(recentWeekStartDay.getDate() - 6);
            const recentWeekStart = Date.parse(recentWeekStartDay.toString());

            // in today
            if (targetTime >= todayStart) {
                const now = Date.now();
                const timeToNow = now - targetTime;

                if (timeToNow < 60 * 1000) { // < 1 min
                    displayingTimeString = $localize`:@@CommonJustNow:Just Now`;
                } else if (timeToNow < 60 * 60 * 1000) { // 1 min - 59 min, e.g. 5 min ago
                    const minsAgo = Math.floor(timeToNow / 1000 / 60);
                    displayingTimeString = $localize`:@@CommonMinutesAgo:${minsAgo} min ago`;
                } else if (timeToNow < 60 * 60 * 1000 * 3) { // 1 hour - 3 hour, e.g. 2 h ago
                    const hoursAgo = Math.floor(timeToNow / 1000 / 60 / 60);
                    displayingTimeString = $localize`:@@CommonHoursAgo:${hoursAgo} h ago`;
                } else { // e.g. Today - 12:21 PM
                    displayingTimeString = $localize`:@@CommonToday:Today` + ' - ' + this._LocalizationTimePipe.transform(value, 'short');
                }
            } else if (targetTime >= yesterdayStart) {
                // in yesterday, e.g. Yesterday - 12:21 PM
                displayingTimeString = $localize`:@@CommonYesterday:Yesterday` + ' - ' + this._LocalizationTimePipe.transform(value, 'short');
            } else if (targetTime >= recentWeekStart) {
                // in the recent week, e.g. Wednesday - 12:21 PM
                const targetDateTime: Date = new Date(value);

                displayingTimeString = this._LocalizationService.DayNames[targetDateTime.getDay()] + ' - ' + this._LocalizationTimePipe.transform(value, 'short');
            } else {
                // e.g. 2024-06-17 - 12:21 PM
                displayingTimeString = this._LocalizationDatePipe.transform(value, 'short') + ' - ' + this._LocalizationTimePipe.transform(value, 'short');
            }

            return displayingTimeString;
        } catch {
            return '';
        }
    }
}
